export default "__VITE_ASSET__4abb1013__"